import React from 'react'
import { FormControlLabel, Radio, RadioGroup, withStyles } from '@material-ui/core'
import { StyledInputLabel, StyledSubHeader } from 'components/widgets'
import { getAppColors } from 'lib/constants'

type Tier = 'essential' | 'elite' | 'ultimate'
type SubStatus = 'paid' | 'delinquent' | 'suspended'

const TIER_OPTIONS: Tier[] = ['essential', 'elite', 'ultimate']
const STATUS_OPTIONS: SubStatus[] = ['paid', 'delinquent', 'suspended']

const BrandRadio = withStyles({
  root: {
    color: getAppColors('--color-brand'),
    '&$checked': {
      color: getAppColors('--color-brand'),
    },
  },
  checked: {},
})(Radio)

type Props = {
  subscriptionTierValue: string
  subscriptionStatusValue: string
  onChangeTier: (tier: Tier) => void
  onChangeStatus: (status: SubStatus) => void
  children?: React.ReactNode
}

export const SubscriptionSection = ({
  subscriptionTierValue,
  subscriptionStatusValue,
  onChangeTier,
  onChangeStatus,
  children,
}: Props) => {
  const inputLabelColor = getAppColors('--color-textfield-label')

  return (
    <div style={{ marginTop: 30, marginBottom: 30 }}>
      <StyledSubHeader style={{ marginBottom: 20 }}>{'Subscription'}</StyledSubHeader>

      <div style={{ marginBottom: 16 }}>
        <StyledInputLabel>Subscription Tier</StyledInputLabel>

        <RadioGroup
          row
          value={subscriptionTierValue}
          onChange={e => onChangeTier(e.target.value as Tier)}
          style={{ gap: 12, marginTop: 6 }}
        >
          {TIER_OPTIONS.map(tier => (
            <FormControlLabel
              key={tier}
              value={tier}
              control={<BrandRadio />}
              label={tier}
              style={{ color: inputLabelColor, marginRight: 10 }}
            />
          ))}
        </RadioGroup>
      </div>

      <div style={{ marginBottom: 16 }}>
        <StyledInputLabel>Subscription Status</StyledInputLabel>

        <RadioGroup
          row
          value={subscriptionStatusValue}
          onChange={e => onChangeStatus(e.target.value as SubStatus)}
          style={{ gap: 12, marginTop: 6 }}
        >
          {STATUS_OPTIONS.map(status => (
            <FormControlLabel
              key={status}
              value={status}
              control={<BrandRadio />}
              label={status}
              style={{ color: inputLabelColor, marginRight: 10 }}
            />
          ))}
        </RadioGroup>
      </div>

      {children ? <div style={{ marginTop: 18 }}>{children}</div> : null}
    </div>
  )
}
